import {Component, contentChildren, effect, input, model, output} from '@angular/core';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {CommonModule} from '@angular/common';
import {AppNavigationLinkSubitemComponent} from '../app-navigation-link-subitem/app-navigation-link-subitem.component';

@Component({
    selector: 'app-navigation-link',
    templateUrl: './app-navigation-link.component.html',
    styleUrls: ['./app-navigation-link.component.scss'],
    standalone: true,
    imports: [CommonModule, RouterLink, RouterLinkActive],
})
export class AppNavigationLinkComponent {
    text = input<string>('');
    link = input<string | null>(null);
    icon = input<string>('');
    disabled = input<boolean>(false);
    navigate = output<void>();

    subitems = contentChildren(AppNavigationLinkSubitemComponent);
    isExpanded = model<boolean>(false);

    constructor() {
        // Apply disabled state to all subitems when parent is disabled
        effect(() => {
            const isDisabled = this.disabled();
            this.subitems().forEach(subitem => {
                subitem.disabled.set(isDisabled);
            });
        });
    }

    onClick(): void {
        if (this.subitems().length > 0) {
            // Toggle subitems visibility if there are subitems
            this.isExpanded.set(!this.isExpanded());
        } else if (!this.disabled()) {
            // Otherwise, emit navigate event
            this.navigate.emit();
        }
    }
}
